const state = () => {
  return {
    sc_work_logs: [],
    sc_work_log: {},
    sc_work_log_filters: {},
  }
}

export default state;
